export default "__VITE_ASSET__0HWMAGgo__"